/**
 * LIVVRA — Direct Buy / Add-to-Cart helpers
 * Loaded globally via theme.liquid
 * Exposes: lvBuyNow(variantId, qty), lvAddToCartAndDraw(variantId, qty, btn)
 */
(function() {
  'use strict';

  /* ── Helper: open the header cart drawer ── */
  function openDrawer() {
    if (window.LIVVRA && window.LIVVRA.openCartDrawer) {
      window.LIVVRA.openCartDrawer();
    }
  }

  function refreshAndOpenDrawer() {
    var refresh = window.LIVVRA && window.LIVVRA.refreshCartDrawer
      ? window.LIVVRA.refreshCartDrawer()
      : Promise.resolve();
    // Open immediately so the customer gets instant feedback; hydrate the
    // drawer in the background instead of waiting for a full section render.
    openDrawer();
    return Promise.resolve(refresh).catch(function() {});
  }

  function addItem(variantId, qty) {
    return fetch('/cart/add.js', {
      method : 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body   : JSON.stringify({ id: variantId, quantity: qty }),
    }).then(function(response) {
      return response.json().then(function(data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'add failed');
        }
        return data;
      });
    });
  }

  /* ── Add to Cart → cart drawer kholo (right se left) ── */
  window.lvAddToCartAndDraw = function(variantId, qty, btn) {
    if (btn && btn.dataset.lvAdding === 'true') return;
    qty = qty || 1;
    var orig = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.dataset.lvAdding = 'true';
      btn.innerHTML = '⏳ Adding…';
    }

    addItem(variantId, qty)
    .then(function() {
      if (btn) btn.innerHTML = '✓ Added!';
      refreshAndOpenDrawer();
      setTimeout(function() {
        if (btn) {
          btn.innerHTML = orig;
          btn.disabled = false;
          delete btn.dataset.lvAdding;
        }
      }, 1800);
    })
    .catch(function() {
      if (btn) {
        btn.innerHTML = orig;
        btn.disabled = false;
        delete btn.dataset.lvAdding;
      }
      refreshAndOpenDrawer();
    });
  };

  /* ── Buy Now → cart drawer kholo (right se left) ── */
  window.lvBuyNow = function(variantId, qty, btn) {
    if (btn && btn.dataset.lvAdding === 'true') return;
    qty = qty || 1;
    var orig = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.dataset.lvAdding = 'true';
      btn.innerHTML = '⏳ Adding…';
    }
    addItem(variantId, qty)
    .then(function() {
      if (btn) btn.innerHTML = '✓ Added!';
      refreshAndOpenDrawer();
      setTimeout(function() {
        if (btn) {
          btn.innerHTML = orig;
          btn.disabled = false;
          delete btn.dataset.lvAdding;
        }
      }, 1800);
    })
    .catch(function() {
      if (btn) {
        btn.innerHTML = orig;
        btn.disabled = false;
        delete btn.dataset.lvAdding;
      }
    });
  };

  /* ── addToCartAjax: used by product-card.liquid snippet ── */
  window.addToCartAjax = function(variantId, qty) {
    var btn = (window.event && window.event.target) ? window.event.target.closest('button') : null;
    window.lvAddToCartAndDraw(variantId, qty || 1, btn);
  };

  /* ── Wire up .lv-atc-btn buttons that have data-variant attr ── */
  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.lv-atc-btn[data-variant]');
      if (!btn) return;
      // Product-card buttons already call lvAddToCartAndDraw inline.
      if (btn.getAttribute('onclick')) return;
      e.preventDefault();
      e.stopPropagation();
      var variantId = parseInt(btn.getAttribute('data-variant'), 10);
      if (!variantId) return;
      window.lvAddToCartAndDraw(variantId, 1, btn);
    });
  });

})();
